import styled from '@bd/bdui-styles/emotion';
import { FavoriteEdit } from '../../bdcoreCandidates/Favorites';
import { colors } from '../../styles';

export default styled(FavoriteEdit)`
  margin:0 auto;
  outline:none;

  &.FavoriteEdit {
    width: 22px;
    background: url(/images/icon-file.svg);
    height: 22px;
    background-repeat: no-repeat;
    transition: all .25s ease;
    background-position: center;
    background-size:20px;
    &-hasValue {
      background-image: url(/images/icon-file-checked.svg);
    }
  }
  .FavoriteEdit_Body {

    .btn {
      display: inline-block;
      line-height: 38px;
      height: 40px;
      margin: 0 10px 0 0;
      cursor: pointer;
      color: ${colors.brand2};
      font-size: 14px;
      font-weight: 700;
      text-align: center;
      border: 0;
      padding: 0 10px 0 10px;
      border: 1px solid black;
      border-radius: 5px;
      background-image: url(/images/icon-triangle-green.svg);
      background-position: calc(100% - 12px) center;
      background-repeat: no-repeat;
      background-color: ${colors.body};
      -webkit-transition: all .25s ease;
      transition: all .25s ease;
      outline: 0;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Favorites/FavoriteEdit.js